
import imgStudent from "../assets/images/icons/student.svg";
import imgFee from "../assets/images/icons/fee.svg";
import imgmonthlytask from "../assets/images/icons/monthly-task.svg";
import imgAnnualtask from "../assets/images/icons/annual-task.svg";
import imgCertificate from "../assets/images/icons/certificate.svg";
import imgSMS from "../assets/images/icons/sms.svg";
import imgLibrary from "../assets/images/icons/library.svg";
import reports from "../assets/images/icons/reports.svg"
import imgPayroll from "../assets/images/icons/payroll.svg"
import imgExamination from "../assets/images/icons/exam.svg"
import imgSecurity from "../assets/images/icons/security.svg"
import imgAccounts from "../assets/images/icons/accounts.svg"
import imgStore from "../assets/images/icons/store.svg"
import imgStaff from "../assets/images/icons/staff.svg"
import imgStudentAtt from "../assets/images/icons/student-1.svg"
import Invoice from "../assets/images/icons/Invoice.svg"
import Support from "../assets/images/icons/Support.svg"
import Photo from "../assets/images/icons/Photo.svg"
import Voucher from "../assets/images/icons/Voucher.svg"
import Message from "../assets/images/icons/Message.svg"
import Website from "../assets/images/icons/Website.svg"
import DateSheet from "../assets/images/icons/DateSheet.svg"
import Admin from "../assets/images/icons/Admin.svg"
import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { scrollToTop } from './Shared/ScrollOnTop';
import { Modal } from "react-bootstrap";

function Dashboard() {
    const [Group_Name, setGroup_Name] = useState(localStorage.getItem("Group_Name"));
    useEffect(() => {
        document.title = "School System Dashboard";
    }, []);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title>Webiste</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-gray">
                    <div className="dashboard mt-0 bg-gray">
                        <ul className="dashboard-buttons">
                            <li>
                                <Link to="/web-admin/voucher-setting">
                                    <img src={Voucher} alt="Voucher" />
                                    <span>Voucher</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/web-admin/message">
                                    <img src={Message} alt="Banner" />
                                    <span>Message</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/web-admin/administration">
                                    <img src={Admin} alt="Banner" />
                                    <span>Administration</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/web-admin/date-sheet-setting">
                                    <img src={DateSheet} alt="Banner" />
                                    <span>Date Sheet</span>
                                </Link>
                            </li>
                        </ul>
                    </div>


                </Modal.Body>
            </Modal>
            <div className="dashboard">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <ul className="dashboard-buttons">
                                <li>
                                    <NavLink onClick={scrollToTop} to="/students/StudentDashboard">
                                        <img src={imgStudent} alt="" />
                                        <span>Students</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/feesystem/feesystemdashboard">
                                        <img src={imgFee} alt="" />
                                        <span>Fee System</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/MonthlyTasks/MonthlyTasksDashboard">
                                        <img src={imgmonthlytask} alt="" />
                                        <span>Monthly Tasks</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/AnnualTasks/AnnualTasksDashboard">
                                        <img src={imgAnnualtask} alt="" />
                                        <span>Annual Tasks</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/Certificate/CertificateDashboard">
                                        <img src={imgCertificate} alt="" />
                                        <span>Certificate Printing</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/SMSAlert/SMSAlertDashboard">
                                        <img src={imgSMS} alt="" />
                                        <span>Send SMS Alert</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/Library/LibraryDashboard">
                                        <img src={imgLibrary} alt="" />
                                        <span>Library</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/Reports/ReportsDashboard">
                                        <img src={reports} alt="" />
                                        <span>Reports</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/PayRoll/PayRollDashboard">
                                        <img src={imgPayroll} alt="" />
                                        <span>Payroll</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/ExaminationSystem/ExaminationDashboard">
                                        <img src={imgExamination} alt="" />
                                        <span>Examination</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/Security/SecurityDashboard">
                                        <img src={imgSecurity} alt="" />
                                        <span>Security</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/Accounts/AccountsDashboard">
                                        <img src={imgAccounts} alt="" />
                                        <span>Accounts</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/StockManagement/StocksDashboard">
                                        <img src={imgStore} alt="" />
                                        <span>Stocks</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/StaffAttendance/StaffAttendanceDashboard">
                                        <img src={imgStaff} alt="" />
                                        <span>Staff Attendance</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/StudentAttendance/StudentAttendanceDashboard">
                                        <img src={imgStudentAtt} alt="" />
                                        <span>Student Attendance</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to="/invoice/manage-invoice">
                                        <img src={Invoice} alt="" />
                                        <span>Invoicing</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={scrollToTop} to={`${Group_Name == "Administrator" ? '/admin-support/support-dashboard' : '/support/raise-ticket'}`}>
                                        <img src={Support} alt="" />
                                        <span>Support</span>
                                    </NavLink>
                                </li>
                                <li className={`${Group_Name == "Administrator" ? '' : 'd-none'}`}>
                                    <NavLink onClick={scrollToTop} to={`${Group_Name == "Administrator" ? '/photo/manage-photo' : ''}`}>
                                        <img src={Photo} alt="" />
                                        <span>Update Photo request</span>
                                    </NavLink>
                                </li>
                                <li onClick={handleShow}>
                                    <a href="#" type="button">
                                        <img src={Website} alt="" />
                                        <span>Website</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default Dashboard;
